import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _class, _temp2;

import React, { Component } from 'react';
import { ThemeProvider, withTheme } from 'styled-components';

import { defaultGridColumns } from './internal/vars';
import GridColumn from './internal/GridColumnElement';

var defaultSpacing = 'cosy';

export default withTheme((_temp2 = _class = function (_Component) {
  _inherits(AkGridColumn, _Component);

  function AkGridColumn() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AkGridColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AkGridColumn.__proto__ || _Object$getPrototypeOf(AkGridColumn)).call.apply(_ref, [this].concat(args))), _this), _this.getTheme = function (props) {
      return {
        columns: props.theme && props.theme.columns ? props.theme.columns : defaultGridColumns,
        spacing: props.theme && props.theme.spacing ? props.theme.spacing : defaultSpacing,
        isNestedGrid: false
      };
    }, _this.getNestedTheme = function (props) {
      return {
        columns: props.medium,
        spacing: props.theme && props.theme.spacing ? props.theme.spacing : defaultSpacing,
        isNestedGrid: true
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AkGridColumn, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        ThemeProvider,
        { theme: this.getTheme(this.props) },
        React.createElement(
          GridColumn,
          { medium: this.props.medium },
          React.createElement(
            ThemeProvider,
            { theme: this.getNestedTheme(this.props) },
            React.createElement(
              'div',
              null,
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return AkGridColumn;
}(Component), _class.defaultProps = {
  medium: 0
}, _temp2));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/page/dist/esm/GridColumn.js
// module id = 668
// module chunks = 0